import { InferOutput, number } from 'valibot'

export const VisionSchema = number()

export type Vision = InferOutput<typeof VisionSchema>
